import { render } from "./MainTemplate.vue?vue&type=template&id=0171a212&scoped=true"
import script from "./MainTemplate.vue?vue&type=script&lang=js"
export * from "./MainTemplate.vue?vue&type=script&lang=js"

import "./MainTemplate.vue?vue&type=style&index=0&id=0171a212&scoped=true&lang=css"
import "./MainTemplate.vue?vue&type=style&index=1&id=0171a212&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0171a212"]])

export default __exports__